import React from 'react'
import { Box, Heading, Text, VStack } from '@chakra-ui/react'
import Logo from './Logo'

/**
 * Shown instead of the app when the sign-in service address is missing from this build.
 *
 * Without this the app renders nothing at all: sign-in silently fails, every request goes out
 * unauthenticated, and the user is left on a blank page with no way to tell what happened.
 *
 * The wording is deliberately soft and asks nothing of the reader. Whoever sees this is a client
 * who cannot act on it, so naming a cause would only alarm them — it reads as a service blip,
 * which from where they sit is exactly what it is. The detail for the person who *can* fix it
 * goes to the console instead (see App.js).
 */
export const SignInUnavailable = () => (
  <VStack
    as="main"
    minH="100vh"
    justify="center"
    spacing={6}
    px={6}
    textAlign="center">
    <Logo width={120} />

    <Box maxW="30rem">
      <Heading
        as="h1"
        size="lg"
        mb={3}
        fontWeight="semibold">
        We&apos;ll be back shortly
      </Heading>

      <Text
        fontSize="md"
        color="gray.600">
        The Dashboard is temporarily unavailable while we get things running again.
        Please check back in a little while — there&apos;s nothing you need to do.
      </Text>
    </Box>
  </VStack>
)

export default SignInUnavailable
